module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/common/fr-FR/btn_back.png";